export const config = {
  defaultTitle: "Abdelmalek",
  logo: "https://smakosh.com/favicon/logo-48.png",
  author: "Abdelmalek Ennani",
  //   "url": 'https://smakosh.com',
  legalName: "Abdelmalek Ennani",
  defaultDescription:
    "I'm Abdelmalek Ennani, a software engineering student, web development enthusiast , neural networks & tech in general.",
  socialLinks: {
    twitter: "https://twitter.com/09_abdelmalek",
    github: "https://github.com/Abdelmalek123-Ennani",
    linkedin: "https://www.linkedin.com/in/abdelmalek-ennani-5304411b1/",
    instagram: "https://www.instagram.com/abdelmalik_09/",
    hashnode: "https://abdelmalek.hashnode.dev/",
  },
  googleAnalyticsID: "UA-88875900-1",
  themeColor: "#00c6ff",
  backgroundColor: "#00c6ff",
  social: {
    facebook: "165244147328608",
    twitter: "@smakosh",
  },
  address: {
    city: "Ouarzazate",
    region: "Drâa-Tafilalet",
    country: "Morocco",
    zipCode: "45000",
  },
  contact: {
    email: "abdelmaleke201@gmail.com",
    phone: "+212-628-73-47-15",
  },
  Languages: [
    { lang: "Java", icon: "devicon-java-plain" },
    { lang: "C++", icon: "devicon-cplusplus-plain" },
    { lang: "JavaScript", icon: "devicon-javascript-plain" },
    { lang: "PHP", icon: "devicon-php-plain " },
  ],
  WebDevelopement: [
    { lang: "HTML", icon: "devicon-html5-plain" },
    { lang: "CSS", icon: "devicon-css3-plain" },
    { lang: "ReactJS", icon: "devicon-react-original" },
    { lang: "Bootstrap", icon: "devicon-bootstrap-plain" },
    { lang: "Sass", icon: "devicon-sass-original " },
    { lang: "NodeJS", icon: "devicon-nodejs-plain" },
    { lang: "ExpressJS", icon: "devicon-express-original" },
    { lang: "SQL/MySql", icon: "devicon-mysql-plain" },
    { lang: "Redux", icon: "devicon-redux-original" },
    { lang: "C", icon: "devicon-c-plain" },
    { lang: "Tailwind CSS", icon: "devicon-tailwindcss-original-wordmark" },
  ],
  projects: [
    {
      url_github: "https://github.com/Abdelmalek123-Ennani/ShopNow",
      title: "ShopNow",
      desc: "e-commerce app created using Reacts and Redux",
      url: "https://shopnow-site.netlify.app/",
      languages: ["ReactJS", "SASS", "JavaScript", "Redux Toolkit" , "AOS"],
    },
    {
      url_github:
        "https://github.com/Abdelmalek123-Ennani/Lasels-VPN-Landing-page",
      title: "Lasels VPN Landing page",
      desc: "Lasels VPN Landing page : created using Vanilla JavaScript , SASS , HTML and font awesome",
      url: "https://laselsvpnss.netlify.app/",
      languages : ["JavaScript" , "SASS" , "Font Awesome"]
    },
    {
      url_github:
        "https://github.com/Abdelmalek123-Ennani/coronavirus-statistics-tracker",
      title: "coronavirus statistics tracker",
      desc: "I built (in 2019) this small app to track the latest coronavirus statistics and last opdated of all countries aroud the world",
      url: "https://covid-21.netlify.app/",
      languages: ["material-ui", "ReactJS" , "axios"],
    },
    {
      url_github: "https://github.com/Abdelmalek123-Ennani/blogSite-Laravel",
      title: "blogSite Laravel",
      desc: "a blog site using laravel and Simantic UI",
      languages: ["PHP", "JavaScript", "Simantic UI", "Laravel"],
    },
  ],
};
